import CardRow from "../card/CardRow";
import FoodGuideCard from "./FoodGuideCard";
import styles from "./FoodGuideCards.module.scss";

export default function FoodGuideCards({
  foods,
  sideScrollButtons = true,
  cardRowRef,
}) {
  if (!foods) return null;
  const cards = foods?.map((food, index) => (
    <FoodGuideCard key={`${food?.id}-${index}`} food={food} index={index} />
  ));

  return (
    <div className={`${styles.foodCards}`}>
      <CardRow
        cards={cards}
        seeAll={false}
        sideScrollButtons={sideScrollButtons}
        sideScroll="all"
        ref={cardRowRef}
        scrollIndicator={true}
      />
    </div>
  );
}
